import React    from 'react'
import { Link } from 'react-router-dom'
import './index.less'

const Home = () => {
  return (
    <div className="home-page">
      <div className="welcome">
        <h2>Welcom</h2>
        <h3>欢迎来到生涯资源库</h3>
        <ul>
          <Link to="/major/list">
            <li className="major">
              <h1>专业库</h1>
              <p>足不出户遍晓天下专业</p>
            </li>
          </Link>
          <Link to="/profession/list">
            <li className="profession">
              <h1>职业库</h1>
              <p>海量职业一网打尽</p>
            </li>
          </Link>
          <Link to="/school/list">
            <li className="school">
              <h1>院校库</h1>
              <p>千百名校任君选择</p>
            </li>
          </Link>
        </ul>
      </div>
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/index.js